/*
Copyright (c) Karsten Jeske and John Firth
This source code is licensed under the proprietary license found in the
LICENSE file in the root directory of this source tree.
*/

export const SESSION_STORAGE_USER_PARAMETERS_KEY = "userParameters"
